import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled(motion.div)`
    grid-area: activityFilters;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    width: 100%;
    position: relative;
    padding: 10px 0 0 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 40px;
        justify-content: unset;
    }
`;

export const FilterButton = styled.div<{ $isActive?: boolean }>`
    padding: 5px 0 15px 0;

    background: none;
    border: none;
    outline: none;

    font-family: 'Alliance No.1';
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.02em;

    color: rgba(255, 255, 255, 0.25);
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
        color: #fff;
    }

    ${({ $isActive }) =>
        $isActive &&
        css`
            color: #fff;
        `};
`;

export const ActiveLine = styled(motion.div)`
    pointer-events: none;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 38px;
    height: 2px;
    background: #fff;
`;
